import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IPartyV1 } from "src/domain/entities"
import { partyDeleteService } from "src/domain/services/party/partyDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	party: IPartyV1
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const PartyDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	party,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handlePartyDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await partyDeleteService({ id: party.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [party, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Party: ${party.name}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handlePartyDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
